var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./About.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-26386464!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./About.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/page/About.vue
// module id = 56
// module chunks = 0